import { Button, Columns, Select, Switch, Text } from "rothzerg-ui";
import type { SortOption } from "@/types/catalog";

const sortOptions = [
  { value: "relevance", label: "Relevance" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
  { value: "rating", label: "Top Rated" },
];

type CategoryToolbarProps = {
  rangeStart: number;
  rangeEnd: number;
  totalCount: number;
  sort: SortOption;
  onSortChange: (sort: SortOption) => void;
  includeMarketplace: boolean;
  onMarketplaceChange: (value: boolean) => void;
  onFilterOpen: () => void;
};

export function CategoryToolbar({
  rangeStart,
  rangeEnd,
  totalCount,
  sort,
  onSortChange,
  includeMarketplace,
  onMarketplaceChange,
  onFilterOpen,
}: CategoryToolbarProps) {
  return (
    <Columns
      align="center"
      justify="between"
      wrap
      style={{ margin: "1rem 0", gap: "1rem" }}
    >
      <Columns align="center" gap="md" wrap>
        <Button id="filter-open" variant="outline" onClick={onFilterOpen}>
          Filter
        </Button>
        <Switch
          id="marketplace-toggle"
          label="Includes Marketplace"
          checked={includeMarketplace}
          onCheckedChange={onMarketplaceChange}
        />
        <Text variant="body" id="product-count">
          {totalCount > 0
            ? `${rangeStart}-${rangeEnd} of ${totalCount} Products`
            : "0 Products"}
        </Text>
      </Columns>

      <div id="sort-select">
        <Select
          options={sortOptions}
          value={sort}
          onValueChange={(v) => onSortChange(v as SortOption)}
          placeholder="Sort"
          label="Sort"
        />
      </div>
    </Columns>
  );
}
